import { useFetch } from '@/hooks/useFetch'
import { Controller } from 'react-hook-form'
import { Select } from 'alurkerja-ui'
import { useContext, useEffect, useState } from 'react'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'

interface ICompanyNamesData {
  id: number
  name: string
}

export default function ListCompanyName() {
  const { data: companyNamesData, isLoading: companyNamesIsLoading } = useFetch({
    path: '/api/v1/odoo/company',
  })

  const [companyNames, setCompanyNames] = useState<ICompanyNamesData[]>([])

  const { setValue, control } = useContext<CustomComponentContextType>(CustomComponentContext)

  const classNamesLabel = "after:content-['*'] after:text-red-400 after:text-sm font-medium"

  useEffect(() => {
    if (companyNamesData && Array.isArray(companyNamesData)) {
      const formattedData = companyNamesData.map(
        (item: any) =>
          ({
            id: item.id,
            name: item.name,
          } as ICompanyNamesData),
      )

      setCompanyNames(formattedData)
    }
  }, [companyNamesData])

  const handleCompanyNameChange = (value: any) => {
    // Set the selected company name
    const selectedCompany = companyNames.find(item => item.id === value.value)

    if (selectedCompany) {
      setValue('company', selectedCompany.name)
      setValue('COMPANY_ID', selectedCompany.id)
    }
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="grid space-x-2">
        <div
          data-testid="COMPANY_NAME"
        >
          <label htmlFor="COMPANY_NAME" className={classNamesLabel}>
            Nama Company
          </label>
          <Controller
            name={'COMPANY_NAME'}
            control={control}
            render={({ fieldState }) => {
              return (
                <>
                  <Select
                    id="COMPANY_NAME"
                    aria-label="Nama Company"
                    options={companyNames.map(item => ({
                      value: item.id,
                      label: item.name,
                    }))}
                    isLoading={companyNamesIsLoading}
                    onChange={value => handleCompanyNameChange(value)}
                  />
                  {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
                </>
              )
            }}
          ></Controller>
        </div>
      </div>
    </div>
  )
}